import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import type { FC } from "react";

import {
  type THeaderMenuLinksProps,
} from "@/ui/components/navigation/Header/Header.config";
import {
  HeaderMenuLink,
} from "@/ui/components/navigation/Header/HeaderMenuLink";
import {
  NAVIGATION_MENU_CONTENT_LIST_CLASS,
  NavigationMenuSeparator,
} from "@/ui/components/navigation/NavigationMenu";
import { cn } from "@/ui/lib/utils";

export const HeaderMenuLinks: FC<THeaderMenuLinksProps> = ({
  className,
  items,
  onNavigate,
  variant,
}) => (
  <ul
    data-component="HeaderMenuLinks"
    className={cn(
      variant === "navigation-menu" ?
        NAVIGATION_MENU_CONTENT_LIST_CLASS :
        "grid w-full",
      "gap-4 md:gap-0",
      className,
    )}
  >
    { items.map((item) => {
      if ("type" in item) {
        return (
          <NavigationMenuSeparator
            key={item.id}
            {...item.itemProps}
            orientation={item.orientation}
            className={item.className}
          />
        );
      }

      const { onClick, ...linkProps } = item.linkProps ?? {};
      const link = (
        <HeaderMenuLink
          {...linkProps}
          href={item.href}
          icon={item.icon}
          className={item.className}
          onClick={(event) => {
            onClick?.(event);

            if (!event.defaultPrevented) { onNavigate?.(); }
          }}
        >
          { item.label }
        </HeaderMenuLink>
      );

      return (
        <li key={item.href}>
          { variant === "navigation-menu" ? (
            <NavigationMenuPrimitive.Link asChild>
              { link }
            </NavigationMenuPrimitive.Link>
          ) : link }
        </li>
      );
    }) }
  </ul>
);

HeaderMenuLinks.displayName = "HeaderMenuLinks";
